import { jsx as t, Fragment as b, jsxs as g } from "react/jsx-runtime";
import { useState as k, useMemo as v, useCallback as A, useLayoutEffect as I } from "react";
import a from "./styles.module.less.js";
import N from "./logo.webp.js";
import { usePathname as C } from "../../../utils/use-pathname.js";
import { AccountLink as E } from "./account-link/index.js";
import { FLOATING_CONTAINER_ID as m } from "./index.js";
import { areasOfLawData as $ } from "../../../constants.js";
import { convertToKebabCase as D } from "../../../utils/case-conversion.js";
import { DropdownMenuItemDesktop as M } from "./dropdown-menu-item/index.js";
import { MenuItem as L } from "./menu-item/index.js";
import { ForLawyersMenuButtonDesktop as S } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemDesktop as T } from "./get-help-menu-item/index.js";
import { MenuChatButtonDesktop as P } from "./chat-button/index.js";
const R = "/help", Q = (s) => {
  const {
    getTranslation: r,
    language: e,
    isLawyerSupported: d = !1,
    lmpEnabled: f = !1,
    hideLinks: y = !1
  } = s, n = C(), [i, p] = k(!1), c = v(() => {
    const o = $[e];
    if (o)
      return [
        ...o.map((u) => ({
          ...u,
          path: `/${e}/topics/${D(u.title)}`
        }))
      ];
  }, [e]), l = A(
    (o) => {
      switch (o) {
        case "/chat":
          return n === "/chat";
        case "/about":
          return n === `/${e}/about`;
        case "/about/company":
          return n === `/${e}/about/company`;
        case "/help":
          return n === R;
        case "/find":
          return n.endsWith(
            "/find"
            /* BROWSE_LAWYERS */
          );
        case "/topics":
          return n === `/${e}/topics`;
        case "/account":
          return n === "/account";
        case "/for-lawyers/legal-network":
          return n === `/${e}/for-lawyers/legal-network`;
        default:
          return !1;
      }
    },
    [n, c, e]
  );
  return I(() => {
    const o = () => {
      var h, w;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? ((h = document.getElementById(m)) == null || h.classList.add(a.shrink), p(!0)) : ((w = document.getElementById(m)) == null || w.classList.remove(a.shrink), p(!1));
    };
    return window.addEventListener("scroll", o), document.body.addEventListener("scroll", o), o(), () => {
      window.removeEventListener("scroll", o), document.body.removeEventListener("scroll", o);
    };
  }, []), /* @__PURE__ */ t(b, { children: /* @__PURE__ */ t("div", { className: a.floatingContainer, id: m, children: /* @__PURE__ */ g("div", { className: a.menuContentContainer, children: [
    /* @__PURE__ */ t(
      "a",
      {
        href: e ? `/${e}` : "/",
        className: a.logoContainer,
        children: /* @__PURE__ */ t(
          "img",
          {
            src: N,
            alt: "LawConnect Logo",
            width: 0,
            height: 20,
            className: a.logo
          }
        )
      }
    ),
    !y && /* @__PURE__ */ g("div", { className: a.menuLinksContainer, children: [
      d ? /* @__PURE__ */ t(
        T,
        {
          language: e,
          titleLabel: r("pages.get-help"),
          getTranslation: r,
          hasShrunk: i,
          isLawyerSupported: !0,
          onRequestLawyer: s.onRequestLawyer,
          isActive: l(
            "/help"
            /* HELP */
          )
        }
      ) : /* @__PURE__ */ t(
        P,
        {
          getTranslation: r,
          isScrolledHeader: i
        }
      ),
      d ? null : /* @__PURE__ */ t("div", { className: a.spacer }),
      f ? /* @__PURE__ */ t(
        L,
        {
          label: "Browse lawyers",
          path: e ? `/${e}/find` : "/find",
          hasShrunk: i,
          isActive: l(
            "/find"
            /* BROWSE_LAWYERS */
          )
        }
      ) : null,
      c ? /* @__PURE__ */ t(
        M,
        {
          language: e,
          items: c,
          titleLabel: r("pages.legal-topics"),
          hasShrunk: i,
          link: `/${e}/topics`,
          classNames: {
            container: a.subMenuContainer,
            itemRow: a.offsetDropdownItemRow
          },
          isActive: l(
            "/topics"
            /* KNOWLEDGE_BASE */
          )
        }
      ) : null,
      f ? null : /* @__PURE__ */ t(
        L,
        {
          label: r("pages.about"),
          path: `/${e}/about/company`,
          hasShrunk: i,
          isActive: l(
            "/about/company"
            /* ABOUT_COMPANY */
          )
        }
      ),
      /* @__PURE__ */ t(
        S,
        {
          language: e,
          getTranslation: r,
          isScrolledHeader: i,
          isActive: l(
            "/for-lawyers/legal-network"
            /* FOR_LAWYERS */
          )
        }
      ),
      /* @__PURE__ */ t(
        E,
        {
          isScrolledHeader: i,
          isActive: l(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: s.isAuthenticated,
          userImage: s.userImage,
          openAuthModal: s.openAuthModal,
          logout: s.logout,
          hasNotifications: s.hasNotifications,
          language: e,
          getTranslation: r
        }
      )
    ] })
  ] }) }) });
};
export {
  Q as DesktopMenu
};
